import React from 'react'

import { BUSINESS_EVENT_LABEL_MAP, BusinessEvent, BusinessEventType } from '../../../models/BusinessEvent'

import { BusinessEventIcon } from '../BusinessEventIcon/BusinessEventIcon'

import './DetectedBusinessEventTypes.scss'

const _MAX_BUSINESS_EVENT_TYPES_TO_DISPLAY = 2

interface DetectedBusinessEventTypesProps {
  businessEvents: BusinessEvent[]
  handleClick: () => void
  className?: string
}

export const DetectedBusinessEventTypes: React.FC<DetectedBusinessEventTypesProps> = ({ businessEvents, handleClick, className = '' }) => {
  const businessEventsByType = businessEvents.reduce<Partial<Record<BusinessEventType, BusinessEvent[]>>>((acc, businessEvent) => {
    const { type } = businessEvent
    const businessEventsByType = acc[type]

    if (!businessEventsByType) {
      return { ...acc, [type]: [businessEvent] }
    }

    return { ...acc, [type]: [...businessEventsByType, businessEvent] }
  }, {})

  const businessEventTypesToDisplay = Object.keys(businessEventsByType).slice(0, _MAX_BUSINESS_EVENT_TYPES_TO_DISPLAY) as BusinessEventType[]

  const displayedBusinessEventCount = businessEvents.reduce<number>((acc, businessEvent) => {
    if (businessEventTypesToDisplay.includes(businessEvent.type)) {
      return acc + 1
    }
    return acc
  }, 0)

  const remainingBusinessEventCount = businessEvents.length - displayedBusinessEventCount

  if (!businessEvents.length) {
    return null
  }

  return (
    <div className={`d-flex align-items-center gap-3 zocks-px-2.0 py-3 ${className}`}>
      <div className='d-flex align-items-center gap-2'>
        <BusinessEventIcon />
        <span className='lead-small'>Client Signals</span>
      </div>
      <div className='d-flex align-items-center gap-2'>
        {businessEventTypesToDisplay.map((businessEventType) => {
          const businessEvents = businessEventsByType[businessEventType]
          if (!businessEvents) {
            return null
          }

          return (
            <div
              key={businessEventType}
              className='d-flex align-items-center px-2 py-1 gap-1 rounded-1 detected-business-event-type-wrapper cursor-pointer'
              onClick={handleClick}
            >
              <span className='paragraph-small'>{BUSINESS_EVENT_LABEL_MAP[businessEventType]}</span>
              {businessEvents.length > 1 ? (
                <div className='detected-business-event-count-for-type-wrapper d-flex align-items-center justify-content-center'>
                  <span className='paragraph-extra-small'>{businessEvents.length}</span>
                </div>
              ) : null}
            </div>
          )
        })}
        {remainingBusinessEventCount ? (
          <span
            className='paragraph-small bold text-decoration-underline px-2 py-1 cursor-pointer rounded-1 detected-business-event-type-more-button'
            onClick={handleClick}
          >
            + {remainingBusinessEventCount} more
          </span>
        ) : null}
      </div>
    </div>
  )
}
